import { Auditlog } from "@encoo-web/encoo-lib";
import { createModel } from "nyax";
import { createItemsEntityModel } from "src/store/itemsEntity";

export const AuditlogEntityModel = createModel(
  class extends createItemsEntityModel<Auditlog>((item) => item.id) {
    public selectors() {
      return {
        ...super.selectors(),
      };
    }
  }
);
